export default __webpack_public_path__ + "static/media/iconePlus.50fb515b.svg";